<template>
	<div class="mx-3">
		<BackHeader class="mb-4" @onBackClicked="onBackClicked">Back to payment options</BackHeader>
		<div class="title">Clover Account Information</div>
		<div class="row-lg mt-4">
			<div class="col-lg-4">
				<!--				<div class="subtitle pb-2">Stripe Account Integration</div>-->
				<div>
					Here is the information about your connected Clover account
				</div>

			</div>
			<div class="col">
				<div class="card py-4 px-4 qwoach-form">


					<FormTextRow
						v-if="paymentIntegrationItemData.merchantName"
						:isVertical="true"
						:disabled="isIntegrated"
						title="Clover Merchant Name"
						v-model="paymentIntegrationItemData.merchantName"/>
					<FormTextRow
						:isVertical="true"
						:disabled="isIntegrated"
						title="Clover Merchant Id"
						v-model="paymentIntegrationItemData.merchantId"/>
				</div>


			</div>
		</div>
	</div>
</template>

<script>
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import BasePaymentIntegrationView
	from "@/core/modules/coach/Billing/view/PaymentIntegrations/Options/BasePaymentIntegrationView.vue";
import BackHeader from "@/core/components/BackHeader.vue";
import CloverIntegrationItem from "@shared/Billing/CloverIntegrationItem";

export default {
	name: "CloverPaymentIntegration",
	extends: BasePaymentIntegrationView,
	components: {BackHeader, FormTextRow},


	methods: {
		createPaymentIntegrationItem() {
			return new CloverIntegrationItem()
		},

	},

	computed: {
		isIntegrated() {
			return this.paymentIntegrationItemData.integrated()
		}
	}

}
</script>

<style>

</style>
